import React from 'react';
import GPT from '@op/components/GPT';
import './index.scss';
import { GPT_TRIGGER_AGENT } from '@op/components/GPT/constants';

export default function GPTTriggerAgent(props: any) {
  const { defaultValue } = props;
  const { triggerModalType } = defaultValue || {}; 

  return (
    <div className="dbo-gpt-agent-wrapper">
      <GPT.AgentOptions
        options={GPT_TRIGGER_AGENT}
        gptType={triggerModalType || 'gemini_3_flash'}
        setGptType={() => {}}
      ></GPT.AgentOptions>
    </div>
  );
}
